import { PageHeader } from "../components/common";
import CashflowView from "../components/CashflowView";
import { useAuth } from "../context/AuthContext";

export default function IncassiDiversi() {
  const { can } = useAuth();
  return (
    <div>
      <PageHeader title="Incassi diversi" subtitle="Entrate e uscite di altre aziende o attività · tenute separate dai conti TENDItaly" />
      <CashflowView ledger="diversi" canEdit={can("edit_payments")} />
    </div>
  );
}
